// Global Instructions Rule Applied!

import React, { forwardRef } from 'react'
import { Switch } from 'antd'
import { InputSize, FieldValue } from '../types.ts'

export interface SwitchInputProps {
  value: FieldValue
  onChange: (value: boolean) => void
  onKeyDown?: (e: React.KeyboardEvent) => void
  size?: InputSize
  disabled?: boolean
  checkedChildren?: React.ReactNode
  unCheckedChildren?: React.ReactNode
}

export const SwitchInput = forwardRef<any, SwitchInputProps>(
  (
    { value, onChange, onKeyDown, size = 'small', disabled = false, checkedChildren = 'Yes', unCheckedChildren = 'No' },
    ref
  ) => {
    const handleChange = (checked: boolean) => {
      onChange(checked)
    }

    // Ant Design Switch only supports 'default' and 'small' sizes
    const switchSize = size === 'small' ? 'small' : 'default'

    return (
      <Switch
        ref={ref}
        checked={Boolean(value)}
        onChange={handleChange}
        size={switchSize}
        disabled={disabled}
        checkedChildren={checkedChildren}
        unCheckedChildren={unCheckedChildren}
      />
    )
  }
)

SwitchInput.displayName = 'SwitchInput'
